/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./node.vue?vue&type=template&id=5326b10c&scoped=true&"
import script from "./node.vue?vue&type=script&lang=js&"
export * from "./node.vue?vue&type=script&lang=js&"
import style0 from "./node.vue?vue&type=style&index=0&id=5326b10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326b10c",
  null
  
)

export default component.exports